import * as React from 'react';
import { Layout } from 'antd';
import classNames from 'classnames';
import { renderFestivalClassName } from '@utils/.';
import { useAppLayout } from '@context/LayoutContext';
// import './index.less';
require('./index.less');

const { Header } = Layout;

export type TopNavHeaderProps = {
  className?: string;
  prefixCls?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  festival?: string;
};

const TopNavHeader = (props: TopNavHeaderProps) => {
  const { className: propsClassName, children, style, festival } = props;
  const { isMobile } = useAppLayout();
  const prefixCls = `${props.prefixCls || 'ant-pro'}-top-nav-header`;

  const className = classNames(
    prefixCls,
    propsClassName,
    renderFestivalClassName(festival || '', { chrismas: 'chrismas', tet: 'tet' }, 'light'),
    isMobile ? 'mobile-header' : '',
  );

  return (
    <Header className={className} style={style}>
      {children}
    </Header>
  );
};

export default TopNavHeader;
